/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReceiptItemDto
 */
export interface ReceiptItemDto {
    /**
     * Nazwa pozycji
     * @type {string}
     * @memberof ReceiptItemDto
     */
    name: string;
    /**
     * Ilość pozycji
     * @type {number}
     * @memberof ReceiptItemDto
     */
    quantity: number;
    /**
     * Cena pozycji
     * @type {string}
     * @memberof ReceiptItemDto
     */
    price: string;
    /**
     * Wartość VAT
     * @type {string}
     * @memberof ReceiptItemDto
     */
    vat: string;
}

/**
 * Check if a given object implements the ReceiptItemDto interface.
 */
export function instanceOfReceiptItemDto(value: object): value is ReceiptItemDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    if (!('price' in value) || value['price'] === undefined) return false;
    if (!('vat' in value) || value['vat'] === undefined) return false;
    return true;
}

export function ReceiptItemDtoFromJSON(json: any): ReceiptItemDto {
    return ReceiptItemDtoFromJSONTyped(json, false);
}

export function ReceiptItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReceiptItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'quantity': json['quantity'],
        'price': json['price'],
        'vat': json['vat'],
    };
}

export function ReceiptItemDtoToJSON(value?: ReceiptItemDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'quantity': value['quantity'],
        'price': value['price'],
        'vat': value['vat'],
    };
}

